import z from "zod";

export const breadcrumbDataSchema = z.object({
  items: z
    .array(
      z.object({
        label: z.string().describe("Visible label for this crumb."),
        href: z
          .string()
          .optional()
          .describe("Navigation target. Omitted for the current page."),
        active: z
          .boolean()
          .optional()
          .describe(
            "Marks the current page — rendered as non-interactive text.",
          ),
        icon: z
          .string()
          .optional()
          .describe("Optional Lucide icon name shown before the label."),
      }),
    )
    .default([])
    .describe(
      "Crumbs parsed from the light DOM (<rwc-breadcrumb-item> elements) — not a Twig-authored attribute.",
    ),
});

export type BreadcrumbDataProps = z.infer<typeof breadcrumbDataSchema>;
